module.exports = __webpack_public_path__ + "static/media/ambassador-form-image.97bc5b0a.png";